// Which muscles each lift works, for the body card on Today (Kenny, 2026-11-02). Pure, no DB.
// main = what the lift is for; help = what assists. General anatomy, cross-checked against the
// open free-exercise-db list; not from the book and not a measured amount of work.

export const MUSCLE_NAMES = {
  chest: 'Chest', frontDelts: 'Shoulders', rearDelts: 'Rear shoulders', triceps: 'Triceps', biceps: 'Biceps', forearms: 'Forearms',
  upperBack: 'Lats and mid back', traps: 'Traps', lowerBack: 'Lower back', abs: 'Abs', obliques: 'Obliques',
  quads: 'Quads', glutes: 'Glutes', hamstrings: 'Hamstrings', adductors: 'Inner thigh', calves: 'Calves',
};

const M = (main, help = '') => ({ main: main.split(' '), help: help ? help.split(' ') : [] });
const PRESS = M('chest', 'frontDelts triceps');
const INCLINE = M('chest frontDelts', 'triceps');
const FLY = M('chest', 'frontDelts');
const OVERHEAD = M('frontDelts', 'triceps traps');
const SIDE = M('frontDelts', 'rearDelts traps');
const REAR = M('rearDelts', 'traps upperBack');
const TRI_PRESS = M('triceps', 'chest frontDelts');
const TRI = M('triceps');
const PULL_FLOOR = M('lowerBack glutes hamstrings', 'upperBack traps forearms quads');
const HINGE = M('hamstrings glutes', 'lowerBack forearms');
const ROW = M('upperBack', 'biceps rearDelts forearms');
const BENT_ROW = M('upperBack', 'biceps rearDelts forearms lowerBack');
const VERTICAL = M('upperBack', 'biceps forearms');
const CHIN = M('upperBack biceps', 'forearms');
const CURL = M('biceps', 'forearms');
const SQUAT = M('quads glutes', 'hamstrings lowerBack adductors');
const MACHINE_SQUAT = M('quads', 'glutes hamstrings');
const LUNGE = M('quads glutes', 'hamstrings');
const LEG_CURL = M('hamstrings', 'calves');
const THRUST = M('glutes', 'hamstrings');
const CALF = M('calves');
const AB = M('abs', 'obliques');
const TWIST = M('obliques', 'abs');

export const LIFT_MUSCLES = {
  bench: PRESS, 'db-bench': PRESS, 'machine-chest-press': PRESS, 'incline-bench': INCLINE, 'incline-db-bench': INCLINE, 'incline-machine-chest-press': INCLINE,
  dip: M('chest triceps', 'frontDelts'), 'push-up': M('chest', 'triceps frontDelts abs'), 'db-fly': FLY, 'pec-deck': FLY, 'cable-crossover': FLY, 'incline-db-fly': M('chest frontDelts'),
  ohp: OVERHEAD, 'seated-ohp': OVERHEAD, 'seated-db-press': OVERHEAD, 'arnold-press': OVERHEAD, 'machine-shoulder-press': OVERHEAD,
  'side-raise': SIDE, 'cable-side-raise': SIDE, 'machine-side-raise': SIDE, 'front-raise': M('frontDelts'),
  'rear-raise': REAR, 'reverse-fly': REAR, 'rear-delt-row': REAR, 'db-rear-delt-row': REAR, 'cable-facepull': REAR,
  'close-grip-bench': TRI_PRESS, 'jm-press': TRI_PRESS, 'close-grip-db-bench': TRI_PRESS, 'bench-dip': TRI_PRESS, 'triangle-push-up': M('triceps chest', 'frontDelts abs'),
  pushdown: TRI, 'seated-triceps-press': TRI, skullcrusher: TRI, 'db-skullcrusher': TRI, 'triceps-kickback': TRI, 'overhead-cable-ext': TRI,
  deadlift: PULL_FLOOR, 'trap-bar-deadlift': M('glutes hamstrings quads', 'lowerBack upperBack traps forearms'), 'sumo-deadlift': PULL_FLOOR, 'db-deadlift': PULL_FLOOR, 'rack-pull': M('lowerBack traps glutes', 'upperBack hamstrings forearms'),
  rdl: HINGE, 'db-rdl': HINGE, 'good-morning': M('hamstrings glutes', 'lowerBack'), 'single-leg-db-deadlift': M('hamstrings glutes', 'lowerBack'),
  'barbell-row': BENT_ROW, 'yates-row': BENT_ROW, 't-bar-row': BENT_ROW, 'two-arm-db-row': BENT_ROW, 'one-arm-row': ROW, 'helms-row': ROW, 'seal-row': ROW, 'machine-row': ROW,
  'seated-cable-row': M('upperBack', 'biceps traps rearDelts'), 'seated-cable-row-wide': M('upperBack', 'biceps traps rearDelts'),
  'lat-pulldown': VERTICAL, 'pull-up': VERTICAL, 'assisted-pull-up': VERTICAL, 'lat-pushdown': M('upperBack'), 'chin-up': CHIN, 'band-chin-up': CHIN, 'negative-chin-up': CHIN,
  'db-shrug': M('traps', 'forearms'), 'back-extension': M('lowerBack', 'glutes hamstrings'),
  'barbell-curl': CURL, 'alt-db-curl': CURL, 'hammer-curl': CURL, 'ez-curl': CURL, 'ez-preacher-curl': CURL, 'db-preacher-curl': CURL, 'cable-curl': CURL, 'incline-db-curl': CURL, 'concentration-curl': CURL, 'reverse-curl': M('forearms biceps'),
  squat: SQUAT, 'safety-bar-squat': SQUAT, 'zercher-squat': SQUAT, 'pit-shark': SQUAT, 'front-squat': M('quads', 'glutes abs lowerBack'), 'db-front-squat': M('quads', 'glutes abs'), 'goblet-squat': M('quads glutes', 'abs hamstrings'),
  'leg-press': MACHINE_SQUAT, 'hack-squat': MACHINE_SQUAT, 'leg-extension': M('quads'),
  'db-lunge': LUNGE, 'db-reverse-lunge': LUNGE, bulgarian: LUNGE, 'db-split-squat': LUNGE, 'barbell-split-squat': LUNGE, 'barbell-lunge': LUNGE,
  'leg-curl': LEG_CURL, 'lying-leg-curl': LEG_CURL, 'nordic-curl': M('hamstrings', 'glutes calves'),
  'hip-thrust': THRUST, 'glute-bridge': THRUST, 'db-hip-thrust': THRUST, 'single-leg-hip-thrust': THRUST, 'cable-kickback': THRUST, 'machine-glute-kickback': THRUST,
  'hip-abduction': M('glutes'), 'cable-hip-abduction': M('glutes'), 'hip-adduction': M('adductors'),
  'step-up': M('glutes quads', 'hamstrings'), 'sumo-squat': M('glutes quads adductors', 'hamstrings'), 'curtsy-lunge': M('glutes quads', 'adductors'), 'cable-pull-through': M('glutes hamstrings', 'lowerBack'),
  'calf-raise': CALF, 'seated-calf-raise': CALF, 'leg-press-calf': CALF, 'donkey-calf-raise': CALF, 'single-leg-calf-raise': CALF,
  'cable-crunch': AB, 'hanging-leg-raise': M('abs', 'obliques forearms'), 'captains-chair': AB, 'lying-leg-raise': AB, 'sit-up': AB, 'ab-rollout': M('abs', 'obliques lowerBack'), plank: AB, 'dead-bug': AB, 'reverse-crunch': AB, 'ball-crunch': AB,
  'bicycle-crunch': M('abs obliques'), 'side-plank': TWIST, 'russian-twist': TWIST, 'cable-woodchop': TWIST, 'pallof-press': TWIST,
};

// A written-in lift has no entry, so it lights up the muscle chosen when it was written in.
const BY_GROUP = {
  chest: M('chest'), back: M('upperBack'), shoulders: M('frontDelts rearDelts'), biceps: M('biceps'), triceps: M('triceps'),
  quads: M('quads'), hamstrings: M('hamstrings'), glutes: M('glutes'), calves: M('calves'), abs: M('abs'),
};

export function musclesForLift(exercise) {
  return LIFT_MUSCLES[exercise?.id] || BY_GROUP[exercise?.muscle_group] || { main: [], help: [] };
}

// A day's lifts as { main, help }: a muscle that's main for any lift is never listed as help.
export function musclesForDay(exercises) {
  const main = new Set();
  const help = new Set();
  (exercises || []).forEach((ex) => {
    const m = musclesForLift(ex);
    m.main.forEach((x) => main.add(x));
    m.help.forEach((x) => help.add(x));
  });
  main.forEach((x) => help.delete(x));
  return { main: [...main], help: [...help] };
}
